var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPistadetenis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.34141 16.9997C6.10283 21.7826 12.2188 23.4214 17.0017 20.66C18.9513 19.5344 20.3785 17.8514 21.1982 15.9286C22.3895 13.1341 22.2978 9.83304 20.662 6.99972C19.0261 4.1664 16.2132 2.43642 13.1975 2.07088C11.1224 1.81935 8.95127 2.21386 7.00167 3.33946C2.21874 6.10089 0.579992 12.2168 3.34141 16.9997Z",
    stroke: "#2B363D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.197 2.07129C13.197 2.07129 12.9653 5.67 15.4653 10.0001C17.9653 14.3303 21.1977 15.929 21.1977 15.929M2.80469 8.07129C2.80469 8.07129 6.0371 9.67 8.5371 14.0001C11.0371 18.3303 10.8054 21.929 10.8054 21.929",
    stroke: "#2B363D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPistadetenis);
export default __webpack_public_path__ + "static/media/Pista de tenis.42b65ed794fb69f0fbf8e4e4d5cf6e26.svg";
export { ForwardRef as ReactComponent };